import moment from "moment";

function convertUTCToTimezone(utcTime, timezone, format) {
  if (timezone) {
    // Check if moment-timezone is available
    if (moment.tz) {
      return moment.utc(utcTime).tz(timezone).format(format);
    } else {
      // Fallback: manually convert to IST (UTC+5:30) if timezone is Asia/Kolkata
      if (timezone === "Asia/Kolkata") {
        const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
        const utcMoment = moment.utc(utcTime);
        const istTime = utcMoment.valueOf() + istOffset;
        return moment(istTime).format(format);
      }
      // For other timezones, try to use moment-timezone if available
      return moment.utc(utcTime).format(format);
    }
  }
  return moment.utc(utcTime).format(format);
}

function convertTimezoneToUTC(timezoneTime, timezone, format) {
  if (timezone) {
    // Check if moment-timezone is available
    if (moment.tz) {
      return moment.tz(timezoneTime, timezone).utc().format(format);
    } else {
      // Fallback: manually convert from IST (UTC+5:30) if timezone is Asia/Kolkata
      if (timezone === "Asia/Kolkata") {
        const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
        const timeMoment = moment(timezoneTime);
        const utcTime = timeMoment.valueOf() - istOffset;
        return moment.utc(utcTime).format(format);
      }
      // For other timezones, try to use moment-timezone if available
      return moment.utc(timezoneTime).format(format);
    }
  }
  return moment.utc(timezoneTime).format(format);
}

function getMonthName(monthIndex) {
  const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  return months[monthIndex];
}

function padZero(number) {
  return number < 10 ? `0${number}` : number;
}
function convertISOStringToUTCFormat(date, timezone, format){
  if (moment.tz) {
    return moment.tz(date, timezone).utc().format(format);
  } else {
    // Fallback: manually convert from IST (UTC+5:30) if timezone is Asia/Kolkata
    if (timezone === "Asia/Kolkata") {
      const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
      const utcTime = moment(date).valueOf() - istOffset;
      return moment.utc(utcTime).format(format);
    }
    return moment.utc(date).format(format);
  }
}
function convertMillisecondsToTime(ms, timezone) {
  ms = parseInt(ms);
  const milliseconds = moment(convertUTCToTimezone(ms, timezone, 'YYYY-MM-DD HH:mm:ss.SSS')).valueOf();
  const date = new Date(milliseconds);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const amOrPm = hours >= 12 ? 'PM' : 'AM';
  if (hours > 12) {
      hours -= 12;
  }
  const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
  const formattedTime = `${hours}:${padZero(minutes)}:${padZero(seconds)} ${amOrPm}`;
  return `${formattedTime}, ${formattedDate}`;
}
function convertMillisecondsToDateTime(ms, timezone,format=null) {
  ms = parseInt(ms);
  
  // Convert UTC milliseconds to target timezone
  let targetMilliseconds = ms;
  if (timezone === "Asia/Kolkata") {
    // IST is UTC+5:30, so add 5.5 hours to UTC timestamp
    const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
    targetMilliseconds = ms + istOffset;
  } else if (moment.tz && timezone) {
    // If moment-timezone is available, use it
    const utcMoment = moment.utc(ms);
    targetMilliseconds = utcMoment.tz(timezone).valueOf();
  }
  
  // Create date object from the adjusted timestamp
  // Since we've already added the offset, we use UTC methods to extract components
  const date = new Date(targetMilliseconds);
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  const amOrPm = hours >= 12 ? 'PM' : 'AM';
  if (hours > 12) {
      hours -= 12;
  }
  if (hours === 0) {
      hours = 12;
  }
  const formattedDate = `${date.getUTCDate()} ${getMonthName(date.getUTCMonth())} ${date.getUTCFullYear()}`;
  const formattedTime1 = `${hours}:${padZero(minutes)} ${amOrPm}`;
  const formattedTime2 = `${hours}:${padZero(minutes)}:${padZero(seconds)} ${amOrPm}`;
  return format==="" ? `${formattedDate}` : format != null ? ` ${formattedDate}, ${format === 'HH:mm:ss' ? formattedTime2 : formattedTime1}` : ` ${formattedDate}, ${formattedTime2}`;
}
function convertMillisecondsTo24HourDateTime(ms, timezone, format = null) {
  ms = parseInt(ms);
  const milliseconds = moment(convertUTCToTimezone(ms, timezone, 'YYYY-MM-DD HH:mm:ss.SSS')).valueOf();
  const date = new Date(milliseconds);
  
  const hours = padZero(date.getHours());
  const minutes = padZero(date.getMinutes());
  const seconds = padZero(date.getSeconds());

  const formattedDate = `${date.getDate()} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
  const formattedTime1 = `${hours}:${minutes}`;
  const formattedTime2 = `${hours}:${minutes}:${seconds}`;

  return format === "" ? `${formattedDate}` 
       : format !== null ? ` ${formattedDate}, ${formattedTime1}` 
       : ` ${formattedDate}, ${formattedTime2}`;
}
function convertMillisecondsToDateTimeForIndicator(ms, timezone, format = "HH:mm, DD/MM/YY") {
  ms = parseInt(ms);
  return moment.tz(ms, timezone).format(format);
}
function convertMillisecondsToTimeStamp(ms, timezone, format) {
  ms = parseInt(ms, 10);
  const milliseconds = convertUTCToTimezone(ms, timezone, format);
  const date = new Date(milliseconds);
  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1);
  const day = padZero(date.getDate());
  const hours = padZero(date.getHours());
  const minutes = padZero(date.getMinutes());
  const seconds = padZero(date.getSeconds());
  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return format === "" ? `${year}-${month}-${day}` : formattedDateTime;
}
const getDuration = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  //@ts-ignore
  const durationInMilliseconds = end - start;

  const days = Math.floor(durationInMilliseconds / (1000 * 60 * 60 * 24));
  const hours = Math.floor((durationInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((durationInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((durationInMilliseconds % (1000 * 60)) / 1000);

  const totalHours = days * 24 + hours;
  //If hours and mins are 0 then show sec and if hours is 0 show min and sec
  if (totalHours === 0 && minutes === 0)
    return `${seconds} Sec`
  else if (totalHours === 0)
    return `${minutes} Min : ${seconds} Sec`
  return `${totalHours} Hrs : ${minutes} Min : ${seconds} Sec`
};

const convertTimezoneOffsetToMillisecond = (timezone) => {
  if (timezone) {
    if (moment.tz) {
      return moment.tz(timezone).utcOffset() * 60 * 1000;
    } else {
      // Fallback: manually calculate offset for IST (UTC+5:30)
      if (timezone === "Asia/Kolkata") {
        return 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
      }
      return 0;
    }
  }
  return 0;
}

/**
 * Transform flat API response into hierarchical structure for sidebar
 * @param {Array} flatData - Array of user guides from API
 * @returns {Array} Hierarchical structure with tabs, subtabs, and pages
 */
const transformUserGuidesToHierarchy = (flatData) => {
  if (!flatData || !Array.isArray(flatData) || flatData.length === 0) {
    return [];
  }

  // Normalize IDs to ensure consistent type comparison (convert to number)
  const normalizeId = (id) => {
    if (id === null || id === undefined) return null;
    return typeof id === 'string' ? parseInt(id, 10) : id;
  };

  // Create a map for quick lookup - use normalized IDs as keys
  const itemMap = new Map();
  flatData.forEach((item) => {
    const normalizedId = normalizeId(item.id);
    itemMap.set(normalizedId, {
      ...item,
      id: normalizedId, // Store normalized ID
      parent_id: normalizeId(item.parent_id), // Normalize parent_id too
      children: [],
    });
  });

  // Build the tree structure
  // First pass: identify all root items (parent_id === null)
  const rootItems = [];
  const processedItems = new Set();
  
  // Process items in two passes to ensure correct hierarchy
  // First pass: identify root items
  flatData.forEach((item) => {
    const normalizedId = normalizeId(item.id);
    const normalizedParentId = normalizeId(item.parent_id);
    const node = itemMap.get(normalizedId);
    
    if (!node) {
      console.warn(`Node not found for id: ${item.id}`);
      return;
    }
    
    // Only add to rootItems if parent_id is truly null/undefined
    if (normalizedParentId === null || normalizedParentId === undefined) {
      rootItems.push(node);
      processedItems.add(normalizedId);
    }
  });
  
  // Second pass: add children to their parents
  flatData.forEach((item) => {
    const normalizedId = normalizeId(item.id);
    const normalizedParentId = normalizeId(item.parent_id);
    
    // Skip if already processed as root item
    if (processedItems.has(normalizedId)) {
      return;
    }
    
    const node = itemMap.get(normalizedId);
    if (!node) {
      return;
    }
    
    // This item has a parent, add it to parent's children
    if (normalizedParentId !== null && normalizedParentId !== undefined) {
      const parent = itemMap.get(normalizedParentId);
      if (parent) {
        parent.children.push(node);
        processedItems.add(normalizedId);
      } else {
        // Parent not found - this shouldn't happen, but handle gracefully
        console.warn(`Parent not found for item id: ${item.id}, parent_id: ${item.parent_id}. Treating as root.`);
        rootItems.push(node);
        processedItems.add(normalizedId);
      }
    }
  });

  // Verify all items were processed
  const totalItems = flatData.length;
  const processedCount = processedItems.size;
  if (processedCount !== totalItems) {
    console.warn(`Tree building: Processed ${processedCount} items out of ${totalItems}. Some items may be missing.`);
  }
  
  // Sort root items and children by id for consistent ordering
  rootItems.sort((a, b) => (a.id || 0) - (b.id || 0));
  
  // Debug: Log the tree structure
  if (process.env.NODE_ENV === 'development') {
    console.log('User Guide Tree Structure:', {
      rootItems: rootItems.map(r => ({ id: r.id, name: r.name, childrenCount: r.children.length })),
      totalItems,
      processedCount
    });
  }
  
  // Transform to sidebar structure
  const transformNode = (node, parentPath = '') => {
    // Sort children by id for consistent ordering
    if (node.children && node.children.length > 0) {
      node.children.sort((a, b) => (a.id || 0) - (b.id || 0));
    }
    
    const hasChildren = node.children && node.children.length > 0;
    
    // Determine if it's a page based on the type field from API
    // API provides explicit "type": "tab" or "type": "page"
    // Use the type field directly - if type is "page", it's a page; otherwise it's a tab/subtab
    const isPage = node.type === "page";
    
    // Build path from hierarchy - use parent path if available
    const path = parentPath ? `${parentPath}/${node.id}` : `/${node.id}`;
    
    return {
      id: node.id,
      uuid: node.uuid,
      title: node.name,
      page: isPage,
      path: path,
      icon: node.icon || null, // Use icon from API response, default to null if not provided
      content: node.content,
      docUrl: node.path,
      publish_version: node.publish_version,
      created_at: node.created_at,
      updated_at: node.updated_at,
      parent_id: node.parent_id, // Keep parent_id for reference
      subtabs: hasChildren ? node.children.map((child) => transformNode(child, path)) : [],
    };
  };

  return rootItems.map(transformNode);
};

export { 
  convertUTCToTimezone, 
  convertTimezoneToUTC, 
  convertMillisecondsToTime, 
  getDuration, 
  convertTimezoneOffsetToMillisecond,
  convertMillisecondsToDateTime,
  convertMillisecondsToTimeStamp,
  convertMillisecondsTo24HourDateTime,
  convertMillisecondsToDateTimeForIndicator,
  convertISOStringToUTCFormat,
  transformUserGuidesToHierarchy
};